module.exports = __webpack_public_path__ + "media/images/plans/e-photo_studio/pickup-2-1d52ccee161c584e895c9781d45f0039.png";